export default {
  apiKey: "AIzaSyBYo70RoVftf0RV5hbB5qLSCQazldZCSpM",
  authDomain: "emc-zdnacloud-scalability-t.firebaseapp.com",
  projectId: "emc-zdnacloud-scalability-t",
  storageBucket: "emc-zdnacloud-scalability-t.appspot.com",
  messagingSenderId: "507285808513",
  appId: "1:507285808513:web:f0f442f451fd411ee77480",
    measurementId: "G-YYKCJJRF05"
}